import { observer } from 'mobx-react-lite';
import { BoloPanelTab } from '../bolo-panel-tab';
import { useBoloPanelMetadata } from '../../../state/bolo-panel-metadata-context';
import { DataItem, DataList } from '@cad-arc';
import { DispatchSection } from '../../../../../panels/entity-panels/tabs/dispatch-section';
import { TabBody } from '../../../../../panels/entity-panels/tabs/tab-body';
import { TabSubtitle } from '../../../../../panels/entity-panels/tabs/tab-subtitle';
import { formatMonthDayYearHoursMinutes } from '../../../../../common/helpers/utils';
import { EntityPanelBoloAssociations } from '../../../../../panels/entity-panels/related-data/entity-panel-bolo-associations';

export const BoloDetailsTab = observer(function BoloDetailsTab() {
    const metadata = useBoloPanelMetadata();

    if (!metadata) {
        return null;
    }

    return (
        <BoloPanelTab title="BOLO Details">
            <TabBody>
                <DataList>
                    <DataItem dataKey="BOLO #">{metadata.boloNumber}</DataItem>
                </DataList>
                <DispatchSection dispatcher={metadata.creator} />
                <TabSubtitle>Timestamps</TabSubtitle>
                <DataList>
                    <DataItem dataKey="Init">
                        {formatMonthDayYearHoursMinutes(metadata.createdDateUtc)}
                    </DataItem>
                    <DataItem dataKey="Trans">
                        {formatMonthDayYearHoursMinutes(metadata.lastUpdatedDateUtc)}
                    </DataItem>
                </DataList>
                <TabSubtitle>Associated Events</TabSubtitle>
                <EntityPanelBoloAssociations
                    panelType="BOLO"
                    associations={metadata.associatedEvents}
                    boloIdForCurrentPanel={metadata.boloId}
                />
                <TabSubtitle>Associated BOLOs</TabSubtitle>
                <EntityPanelBoloAssociations
                    panelType="BOLO"
                    associations={metadata.associatedBolos}
                    boloIdForCurrentPanel={metadata.boloId}
                />
            </TabBody>
        </BoloPanelTab>
    );
});
